var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var a = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    d.call(e, r) && a(o, r, e[r]);
  if (t)
    for (var r of t(e))
      l.call(e, r) && a(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, c(e));
import s, { forwardRef as n } from "react";
import w from "../lib/IconBase.mjs";
import M from "../defs/Medal.mjs";
const R = n((o, e) => /* @__PURE__ */ s.createElement(w, f(m({ ref: e }, o), { weights: M })));
R.displayName = "Medal";
export {
  R as Medal
};
